<template>
  <div class="login_container">
    <!-- <div class="login_title">德阳工程履约保证金系统</div> -->
    <div class="login_box">
      <div class="avatar_box">
        <img src="../assets/logo3.png" />
      </div>
      <el-form
        ref="loginFormRef"
        width="0px"
        :model="user"
        :rules="loginFormRules"
        class="login_form"
      >
        <el-form-item prop="loginName">
          <el-input
            placeholder="请输入用户名"
            v-model="user.loginName"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item prop="passwprd">
          <el-input
            placeholder="请输入密码"
            v-model="user.passwprd"
            type="password"
            prefix-icon="el-icon-key"
          ></el-input>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button @click="register">注 册</el-button>
          <el-button type="primary" @click="login">登 录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <div>主办单位：德阳市住房和城乡建设局</div>
      <div>运营及技术单位: 德阳发展集团 卓远征信</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: {
        loginName: '',
        passwprd: ''
      },
      loginFormRules: {
        loginName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            min: 3,
            max: 10,
            message: '长度在 3 到 10 个字符',
            trigger: 'blur'
          }
        ],
        passwprd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 5,
            max: 18,
            message: '长度在 5 到 18 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {


    login () {
      this.$refs.loginFormRef.validate(async valid => {
        const { data: res } = await this.$http.post('register/login', this.user)
        if (res.code !== 200) return this.$message.error(res.msg)
        this.$message.success(res.msg)
        window.sessionStorage.setItem('id', res.data.id)
        window.sessionStorage.setItem('enterpriseName', res.data.enterpriseName)
        window.sessionStorage.setItem('juridicalPerson', res.data.juridicalPerson)
        window.sessionStorage.setItem('categoryStr', res.data.categoryStr)
        window.sessionStorage.setItem('enterpriseCreditCode', res.data.enterpriseCreditCode)
        window.sessionStorage.setItem('enterpriseAddress', res.data.enterpriseAddress)
        
        this.$router.push('/access')
      })
    },
    register() {
      this.$router.push('/register')
    }
  }
}
</script>

<style lang="scss">
.login_container {
  background-image: url('../assets/backkground.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  
  .footer{
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .login_title{
    position: absolute;
    left: 50%;
    top:25%;
    transform: translate(-50%, -50%);
    color: #666;
    font-size: 20px;
    font-weight: 600;
  }

  .login_box {
    width: 380px;
    height: 260px;
    border-radius: 3px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.avatar_box {
  width: 80px;
  height: 80px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
}
.avatar_box img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #eee;
}
.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
}

.el-input{
  // border: 1px solid #000;
}
.login_button {
  display: flex;
  justify-content: end;
}
</style>
